import { Tabs as TabsBase, TabList, Tab, TabPanel } from 'react-tabs';
import './style.scss';
import { useState } from 'react';

type TabsProps = {
  tabLists: { title: string; extra?: React.ReactNode; disabled?: boolean }[];
  tabContents: React.ReactNode[];
  selectedIndex?: number;
  onSelect?: (index: number) => void;
};

export const Tabs = (props: TabsProps) => {
  const [tabIndex, setTabIndex] = useState(0);
  const { tabLists, tabContents, selectedIndex, onSelect } = props;
  return (
    <TabsBase
      className="react-tabs"
      selectedIndex={selectedIndex || tabIndex}
      onSelect={(index: number) => {
        setTabIndex(index);
        onSelect?.(index);
      }}
    >
      <TabList className="react-tabs__tab-list">
        {tabLists.map((item, index) => (
          <Tab className="react-tabs__tab" key={index} disabled={item.disabled}>
            <span>{item.title}</span>
            {item.extra}
          </Tab>
        ))}
      </TabList>
      {tabContents.map((tabContent, index) => (
        <TabPanel className="react-tabs__tab-panel" key={index}>
          {tabContent}
        </TabPanel>
      ))}
    </TabsBase>
  );
};
